import {ReactNode} from "react";
import styled, {css} from "@yb/styled-px2rem";

interface ListProps {
	children: ReactNode;
	color?: string;
}
// 필요한 color 있으면 추가해서 사용
const Item = styled.li<{color?: string}>`
	position: relative;
	padding-left: 8px;
	font-size: 12px;
	line-height: 1.41;
	color: var(--gray-color);
	word-break: break-word;

	&:before {
		position: absolute;
		top: 6px;
		left: 0;
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background: var(--bl-color);
		content: " ";
	}

	a {
		text-decoration: underline;
	}

	${props => {
		if (props.color === "blue") {
			return css`
				color: var(--blue-color);
			`;
		}
	}}
	${props => {
		if (props.color === "red") {
			return css`
				color: var(--red-color);
			`;
		}
	}}

    strong {
		color: var(--emp-color);
	}
`;

const BulletListItem = ({children, color}: ListProps) => <Item color={color}>{children}</Item>;

export default BulletListItem;
